import React from "react";

function SliderManegerIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="10 12 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 16C14 13.172 14 11.757 14.879 10.879C15.757 10 17.172 10 20 10C22.828 10 24.243 10 25.121 10.879C26 11.757 26 13.172 26 16V24C26 26.828 26 28.243 25.121 29.121C24.243 30 22.828 30 20 30C17.172 30 15.757 30 14.879 29.121C14 28.243 14 26.828 14 24V16Z"
        stroke="#667085"
        strokeWidth="1.5"
      />
      <path
        opacity="0.5"
        d="M26 27.5C27.4 27.5 28.1 27.5 28.635 27.227C29.1051 26.9874 29.4874 26.6051 29.727 26.135C30 25.6 30 24.9 30 23.5V16.5C30 15.1 30 14.4 29.727 13.865C29.4875 13.3945 29.1053 13.0119 28.635 12.772C28.1 12.5 27.4 12.5 26 12.5M14 27.5C12.6 27.5 11.9 27.5 11.365 27.227C10.8945 26.9875 10.5119 26.6053 10.272 26.135C10 25.6 10 24.9 10 23.5V16.5C10 15.1 10 14.4 10.272 13.865C10.5117 13.3944 10.8944 13.0117 11.365 12.772C11.9 12.5 12.6 12.5 14 12.5"
        stroke="#667085"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export default SliderManegerIcon;
